import { LuIcon, Text } from "@overmap-ai/blocks"
import { type Document, type Stored, UNTITLED_DOCUMENT_TITLE } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { ProjectTimelineCard } from "./ProjectTimelineCard"

interface ProjectTimelineDocumentItemProps {
	document: Stored<Document>
}

export const ProjectTimelineDocumentItem = memo<ProjectTimelineDocumentItemProps>((props) => {
	const { document } = props

	const user = useAppSelector(selectUserById(document.created_by ?? -1))

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.DOCUMENT}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;created document&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/documents/$documentId"
					params={{ documentId: document.uuid }}
				>
					<Text highContrast className={interactiveTextCva()}>
						<LuIcon icon={modelIconMapping.document} className="align-sub" />
						&nbsp;{document.title || UNTITLED_DOCUMENT_TITLE}
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(document.submitted_at)}</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineDocumentItem.displayName = "ProjectTimelineDocumentItem"
